import { render, staticRenderFns } from "./PlotData.vue?vue&type=template&id=e5467c52&"
import script from "./PlotData.vue?vue&type=script&lang=js&"
export * from "./PlotData.vue?vue&type=script&lang=js&"
import style0 from "./PlotData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports